import React, { useState } from "react";
import Navbar from "../Navbar";
import "../../App.css";
import "./StreamContent.css";
import CustomizedAccordions from "./CustomizedAccordions";
import CustomizedAccordionsFDE from "./CustomizedAccordiansFDE";
import CustomizedAccordionsAEH from "./CustomizedAccordiansAEH";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { styled } from "@material-ui/core/styles";
import ComingSoonAccordion from "./ComingSoonAccordion";

const Accordion = withStyles({
  root: {
    backgroundColor: "transparent",
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#7500c0 !important",
    color: "#fff",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    alignItems: "center",
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    margin: "12px 0",
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expandIcon: {
    color: "#fff !important",
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: "block",
  },
}))(MuiAccordionDetails);
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: "#fff",
  backgroundColor: "#7500c0",
}));
const ItemData = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: "black",
  backgroundColor: "RGB(238,238,238)",
}));

function StreamContent() {
  const [expanded, setExpanded] = useState("shiftLeft");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <div className="tech-container main-container">
        <title>Job Readiness - Skill Journey</title>
        <h1 class="sr-only" tabIndex={0}>
          Job Readiness - Skill Journey
        </h1>
        <img
          src="/images/skiil-learning-banner.jpg"
          alt="banner-image"
          className="banner-img"
        />
        <Navbar />
        <h2 id="main">
          <span>Skill Learning</span> Overview
        </h2>
        <p>
          A wide range of technology and functional skills across Custom
          Development, Platforms, Cloud, Digital, Data and more are on offer.
          Select a skill below, to know more about its detailed curriculum and
          assessments.
        </p>
        <Container>
          {/* Shift Left Streams */}
          <Accordion
            square
            expanded={expanded === "shiftLeft"}
            onChange={handleChange("shiftLeft")}
          >
            <AccordionSummary>
              <h3 style={{ margin: 0, color: "#fff", flexGrow: 1 }}>
                ASE Streams
              </h3>
              <ExpandMoreIcon className="custom-expand-icon" />
            </AccordionSummary>

            <AccordionDetails>
              <CustomizedAccordions />
              <ComingSoonAccordion />
            </AccordionDetails>
          </Accordion>
<br/><br/>
          {/* Quantum Streams */}
          <Accordion
            square
            expanded={expanded === "aeh"}
            onChange={handleChange("aeh")}
          >
            <AccordionSummary>
              <h3 style={{ margin: 0, color: "#fff", flexGrow: 1 }}>
                QUANTUM CREW Streams
              </h3>
              <ExpandMoreIcon className="custom-expand-icon" />
            </AccordionSummary>

            <AccordionDetails>
              <CustomizedAccordionsAEH/>
            </AccordionDetails>
          </Accordion>
          <br/>
          <br/>

           {/* FDE Streams */}
          <Accordion
            square
            expanded={expanded === "fde"}
            onChange={handleChange("fde")}
          >
            <AccordionSummary>
              <h3 style={{ margin: 0, color: "#fff", flexGrow: 1 }}>
                Entry Level FDE Streams
              </h3>
              <ExpandMoreIcon className="custom-expand-icon" />
            </AccordionSummary>

            <AccordionDetails>
            <CustomizedAccordionsFDE/>
            </AccordionDetails>
          </Accordion>
          <br/>
          <br/>

           {/* <Accordion
            square
            expanded={expanded === "aeh"}
            onChange={handleChange("aeh")}
          >
            <AccordionSummary>
              <h3 style={{ margin: 0, color: "#fff", flexGrow: 1 }}>
                FDE Streams
              </h3>
              <ExpandMoreIcon className="custom-expand-icon" />
            </AccordionSummary>

            <AccordionDetails>
              <CustomizedAccordionsAEH/>
            </AccordionDetails>
          </Accordion>
          <br/>
          <br/> */}

          {/* AASE Streams */}
        {/*   <Accordion
            square
            expanded={expanded === "aase"}
            onChange={handleChange("aase")}
          >
            <AccordionSummary>
              <h3 style={{ margin: 0, color: "#fff", flexGrow: 1 }}>
                AASE Streams
              </h3>
              <ExpandMoreIcon className="custom-expand-icon" />
            </AccordionSummary>

            <AccordionDetails>
              <CustomizedAccordions />
              <ComingSoonAccordion />
            </AccordionDetails>
          </Accordion> */}

          <br />
          <br />
        </Container>
      </div>
    </>
  );
}

export default StreamContent;
